/**
 * The Scenewise owl, traced from the Nano Banana Pro master (1024 px render, coordinates kept in that space).
 * Left eye: a film frame with an inscribed lens. Right eye: a ring. V beak below. `pupil` shifts both pupils
 * sideways, in the old 56-unit scale (about ±2.5).
 */
export function Owl({ pupil = 0, className, title }: { pupil?: number; className?: string; title?: string }) {
  return (
    <svg
      className={className}
      viewBox="195 348 634 328"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeLinecap="round"
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <path d="M380 635.75H213.25V366.25H484.75V534" strokeWidth={25.5} />
      <circle cx="349" cy="500.5" r="133.3" strokeWidth={27.6} />
      <circle cx="674" cy="501" r="134.8" strokeWidth={27.5} />
      <path d="M491 627 512 656 533 627" strokeWidth={26} />
      <g className="sw-pupils" style={{ transform: `translateX(${pupil * 11.3}px)` }}>
        <circle cx="349" cy="500.5" r="33.5" fill="currentColor" stroke="none" />
        <circle cx="674" cy="500.5" r="33.5" fill="currentColor" stroke="none" />
      </g>
    </svg>
  );
}
